import React, { useState, useCallback, useEffect, useRef } from "react";
import { Cross } from "lucide-react";
import { useUser, useOrganization } from "@clerk/clerk-react";
import { useApiFetch, toastError } from "src/lib/api";
import { Button } from "../components/ui/button";
import DashboardFilterBar from "../components/common/DashboardFilterBar";
import WidgetSkeleton from "../components/common/WidgetSkeleton";
import { startOfDay, endOfDay, startOfMonth } from "date-fns";
import { MelodyCounter } from "../components/common/MelodyCounter";
import { createSwapy } from 'swapy'
import { CardDescription, CardHeader, CardTitle, } from "../components/ui/card";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
// [tutorial disabled] import { driver } from "driver.js";
import html2canvas from "html2canvas";
import MyEditor from "../components/common/TextEditor"
import TemperatureDisplay from "../components/common/Temperaturesdisplay";
import VolumeDisplay from "../components/common/Volumedisplay";
import FramesStat from "../components/common/FramesStats";
import DetectionRadial from "../components/common/DetectionRadial";
import "react-datepicker/dist/react-datepicker.css";
import "../styles/Dashboard.css";
import "react-toastify/dist/ReactToastify.css";
// [tutorial disabled] import "driver.js/dist/driver.css";

const frameworks = [
  {
    value: "Device1",
    label: "Device1",
  },
  {
    value: "Device2",
    label: "Device2",
  },
  {
    value: "Device3",
    label: "Device3",
  },
  {
    value: "Device4",
    label: "Device4",
  },
  {
    value: "Device5",
    label: "Device5",
  },
];

const Dashboard = ({ type }) => {
  const [device, setDevice] = useState("");
  /* Date range */
  // Defaults to the current month so far (1st of the month -> today)
  const [startDate, setStartDate] = useState(() => startOfMonth(new Date()));
  const [endDate, setEndDate] = useState(() => endOfDay(new Date()));
  const [data, setData] = useState(null);
  const [devicesAvailable, setDevicesAvailable] = useState(false);
  const [devicesLoading, setDevicesLoading] = useState(true);
  /* MonitorID */
  const [value, setValue] = React.useState("");
  const [appliedDevice, setAppliedDevice] = useState(""); // Device whose data is displayed (set on search)
const { organization } = useOrganization();

  {/* Dashboard stats*/}
  const [devices, setDevices] = useState([]);
  const [product, setProduct] = useState("");
  const [role, setRole] = useState("member")
  const [volume, setVolume] = useState(null); // null = no data
  const [detections, setDetections] = useState([]);
  const [frameDetections, setFrameDetections] = useState([]);
  const [volumeTrend, setVolumeTrending] = useState(null);
  const [tempTrend, setTemperatureTrending] = useState(null);
  const [temperature, setTemperature] = useState(null); // null = no data
  const [melody, setMelody] = useState({});

  const [loading, setLoading] = useState(true); // Estado de carga
  /* Progressive loading: the layout appears as soon as a search starts with placeholders until
     the period data arrives; the trends (overview request, in parallel) fill in when ready */
  const [displayedDevice, setDisplayedDevice] = useState(""); // Device whose layout is shown
  const [searching, setSearching] = useState(false);
  const [statsLoading, setStatsLoading] = useState(false); // Period data (all widgets)
  const [appliedRange, setAppliedRange] = useState(null); // { start, end } of the displayed data
  const searchIdRef = useRef(0); // Ignores responses of a search replaced by a newer one
  const lastShownDeviceRef = useRef(""); // Last search that fully succeeded (restored on error)

  const COMPONENTS_MAP_GRID1 = {
    DetectionRadial: (props) => <DetectionRadial detections={props.detections} startDate={props.startDate} endDate={props.endDate}/>,
    FramesStat: (props) => <FramesStat frameDetections={props.frameDetections} startDate={props.startDate} endDate={props.endDate}/>,
  };

  const COMPONENTS_MAP_GRID2 = {
    TemperatureDisplay: (props) => <TemperatureDisplay temperature={props.temperature} tempTrend={props.tempTrend} startDate={props.startDate} endDate={props.endDate} device={props.value}/>,
    MelodyCounter: (props) => <MelodyCounter melody={props.melody}/>,
    VolumeDisplay: (props) => <VolumeDisplay volume={props.volume} volumeTrend={props.volumeTrend}/>,
  };

  const orgId = organization?.id;

  {/* Token & tole */}
  const { user } = useUser();
  const navigate = useNavigate(); // Hook para redirección
  const apiFetch = useApiFetch();

  // const role = user.organizationMemberships[0].role;

  // [tutorial disabled] const disableTutorial = async () => {
    // [tutorial disabled] try {
      // [tutorial disabled] await apiFetch("/auth/disable-tutorial", { method: "POST" });
    // [tutorial disabled] } catch (error) {
      // [tutorial disabled] console.error("Error disabling tutorial:", error);
    // [tutorial disabled] }
  // [tutorial disabled] };

  // [tutorial disabled] /* Display tour tutorial */
    // [tutorial disabled] useEffect(() => {
    // [tutorial disabled] if (!product || product === "") return;

    // [tutorial disabled] let intervalId = null;
  
    // [tutorial disabled] const checkForTutorialReady = () => {
      // [tutorial disabled] let step = localStorage.getItem("driver-tutorial-step");
      // [tutorial disabled] const el = document.querySelector(".filter-container");
  
      // [tutorial disabled] if (step === "dashboard-v1" && el) {
        // [tutorial disabled] clearInterval(intervalId); 
        // [tutorial disabled] startDriver();

        // [tutorial disabled] setTimeout(() => {
          // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);
        // [tutorial disabled] }, 1000);
      // [tutorial disabled] }
    // [tutorial disabled] };

    // [tutorial disabled] const startDriver = () => {
      // [tutorial disabled] const steps = [
        // [tutorial disabled] {
          // [tutorial disabled] element: ".filter-container",
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "Bar to filter devices by name or date",
            // [tutorial disabled] prevBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
                // [tutorial disabled] nextBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
            // [tutorial disabled] onPrevClick: () => {
              // [tutorial disabled] if( role === "admin") {
                // [tutorial disabled] navigate("/deviceManager");
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "device-manager");
              // [tutorial disabled] } else {
                // [tutorial disabled] navigate("/detection");
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "detections");
              // [tutorial disabled] }
            // [tutorial disabled] },
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onHighlighted: () => {
            // [tutorial disabled] const enablePrev = () => {
              // [tutorial disabled] const prevBtn = document.querySelector('.driver-popover-prev-btn');
              // [tutorial disabled] if (prevBtn) {
                // [tutorial disabled] prevBtn.removeAttribute("disabled");
                // [tutorial disabled] prevBtn.classList.remove('driver-popover-btn-disabled');
                // [tutorial disabled] clearInterval(retry); // Detener intentos
              // [tutorial disabled] }
            // [tutorial disabled] };

            // [tutorial disabled] const retry = setInterval(enablePrev, 100);
            // [tutorial disabled] // opcionalmente corta después de 1s si no se logra
            // [tutorial disabled] setTimeout(() => clearInterval(retry), 1000);
          // [tutorial disabled] },
        // [tutorial disabled] },
        // [tutorial disabled] {
          // [tutorial disabled] element: "#swapyGrid2",
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "Grid that displays live data about melodies, gateway volume and temperature",
            // [tutorial disabled] prevBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
                // [tutorial disabled] nextBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] }
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
        // [tutorial disabled] },
        // [tutorial disabled] {
          // [tutorial disabled] element: "#swapyGrid1",
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "Grid that displays linear charts about detections and frame detections of each device",
            // [tutorial disabled] prevBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
                // [tutorial disabled] nextBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] }
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
        // [tutorial disabled] },
        // [tutorial disabled] {
          // [tutorial disabled] element: "#save-button",
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "Save button for charts distribution",
            // [tutorial disabled] prevBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
                // [tutorial disabled] nextBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
            // [tutorial disabled] onNextClick: () => {
              // [tutorial disabled] if (product !== "audio") {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "dashboard-v2");
                // [tutorial disabled] navigate("/dashboard-v2");
              // [tutorial disabled] } else {
                // [tutorial disabled] disableTutorial();
                // [tutorial disabled] driverObj.moveNext();
              // [tutorial disabled] }
            // [tutorial disabled] },
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] }
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
        // [tutorial disabled] }, 
        // [tutorial disabled] /* {
          // [tutorial disabled] element: "#report",
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "Report file",
            // [tutorial disabled] description: "This section allows you to add unlimited charts to create a simple report within your notes",
            // [tutorial disabled] prevBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
                // [tutorial disabled] nextBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
            // [tutorial disabled] onNextClick: () => {
              // [tutorial disabled] if (product !== "audio") {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "dashboard-v2");
                // [tutorial disabled] navigate("/dashboard-v2");
              // [tutorial disabled] } else {
                // [tutorial disabled] console.log("End of tour");
                // [tutorial disabled] disableTutorial();
                // [tutorial disabled] driverObj.moveNext();
              // [tutorial disabled] }
            // [tutorial disabled] },
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
            // [tutorial disabled] }
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
          // [tutorial disabled] },
        // [tutorial disabled] }, */
        // [tutorial disabled] {
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "End of tour",
            // [tutorial disabled] description: "The tutorial tour has been completed, enjoy your stay!",
            // [tutorial disabled] prevBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
                // [tutorial disabled] nextBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
            // [tutorial disabled] onNextClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
// [tutorial disabled] },
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onHighlighted: () => {
            // [tutorial disabled] if (product !== "audio") {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
            // [tutorial disabled] }
          // [tutorial disabled] }
        // [tutorial disabled] }
      // [tutorial disabled] ];

      // [tutorial disabled] const driverObj = driver({ steps });
      // [tutorial disabled] driverObj.drive();
    // [tutorial disabled] };
  
    // [tutorial disabled] // Poll cada 300ms hasta que estén el paso y el elemento
    // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);
  
    // [tutorial disabled] // Limpieza del intervalo
    // [tutorial disabled] return () => {
      // [tutorial disabled] if (intervalId) clearInterval(intervalId);
    // [tutorial disabled] };
  // [tutorial disabled] }, [product]);

  // Esta función se invoca al pulsar el botón de lupa: es el único punto que carga datos
  const handleFilterClick = async () => {
    if (!value) {
      toast.info("Select a device first");
      return;
    }
    if (!startDate || !endDate) {
      toast.info("Select a start and end date");
      return;
    }
    if (startOfDay(startDate) > endOfDay(endDate)) {
      toast.error("The start date must be before the end date");
      return;
    }

    const searchId = ++searchIdRef.current;
    const isCurrent = () => searchIdRef.current === searchId;
    const deviceChanged = value !== appliedDevice;
    const range = { start: startOfDay(startDate), end: endOfDay(endDate) };

    setSearching(true);
    setDisplayedDevice(value); // Layout with placeholders right away
    setStatsLoading(true);
    if (deviceChanged) {
      // Trends of the previous device must not show next to the new device values
      setVolumeTrending(null);
      setTemperatureTrending(null);
    }

    // Device overview (trends) only when the device changed since the last search
    const overviewRequest = !deviceChanged
      ? Promise.resolve()
      : apiFetch("/api/dashboard", {
          method: "POST",
          body: { monitorId: value },
        }).then((overview) => {
          if (!overview || !isCurrent()) return;
          setVolumeTrending(overview?.volumeTrending ?? null);
          setTemperatureTrending(overview?.temperatureTrending ?? null);
          setAppliedDevice(value);
        });

    const statsRequest = apiFetch("/api/dashboard-filter", {
      method: "POST",
      body: {
        monitorId: encodeURIComponent(value),
        startDate: range.start,
        endDate: range.end,
      },
    })
      .then((data) => {
        if (!data || !isCurrent()) return;
        setVolume(data?.volumeValue ?? null);
        setTemperature(data?.temperatureValue ?? null);
        setMelody(data?.melodiesValues ?? {});
        setDetections(data?.detections ?? []);
        setFrameDetections(data?.frames ?? []);
        setAppliedRange(range);
      })
      .finally(() => {
        if (isCurrent()) setStatsLoading(false);
      });

    const results = await Promise.allSettled([overviewRequest, statsRequest]);
    if (!isCurrent()) return;
    setSearching(false);

    const failure = results.find((r) => r.status === "rejected");
    if (failure) {
      console.error("Error fetching filtered dashboard data:", failure.reason);
      toastError(failure.reason);
      // Back to what was shown before this search (or the empty state)
      setDisplayedDevice(lastShownDeviceRef.current);
    } else {
      lastShownDeviceRef.current = value;
    }
  };

  const [gridMode, setGridMode] = useState(false); // Editor container status (displayed / hidden)
  {/* Editor creation */}

  const editorRef = useRef(null);
  {/* IMG add by users inside the Editor to export*/}
  const [insertedImage, setInsertedImage] = useState([]);

  const handleAddIMG = async (itemId) => {
    const element = document.getElementById(itemId);
    if (!element ) {
      console.warn(`Item with id: "${itemId}, not found"`);
      return;
    }
    const canvas = await html2canvas(element, { backgroundColor: "#fff" });
    const imageDataUrl = canvas.toDataURL("image/png");
    
    setInsertedImage(prev => [...prev, imageDataUrl]);
  };

  {/* Function that waits fro the dashboard to appear to apply swapy grids */}
  function waitForElement(selector, callback, isCancelled = () => false) {
    if (isCancelled()) return;
    const element = document.getElementById(selector);
    if (element) {
      callback(element);
    } else {
      setTimeout(() => waitForElement(selector, callback, isCancelled), 100);
    }
  }

  const [layoutSwapy1, setLayout1] = useState(null);
  const [layoutSwapy2, setLayout2] = useState(null);
  const showCharts = Boolean(displayedDevice);

  // The selection (device / dates) differs from the data on screen: the user must press Search
  const sameDay = (a, b) => Boolean(a && b) && a.getTime() === b.getTime();
  const pendingSearch = !searching && Boolean(value) && Boolean(startDate) && Boolean(endDate) && (
    value !== displayedDevice ||
    !appliedRange ||
    !sameDay(startOfDay(startDate), appliedRange.start) ||
    !sameDay(endOfDay(endDate), appliedRange.end)
  );

  {/* Create swapy grids once the layouts are loaded and the charts are shown, destroy them on cleanup */}
  useEffect(() => {
    if (!layoutSwapy1 || !layoutSwapy2 || !showCharts) return;

    let cancelled = false;
    const instances = [];

    ["swapyGrid1", "swapyGrid2"].forEach((gridId) => {
      waitForElement(gridId, (container) => {
        instances.push(createSwapy(container, { autoScrollOnDrag: true }));
      }, () => cancelled);
    });

    return () => {
      cancelled = true;
      instances.forEach((instance) => instance.destroy());
    };
  }, [layoutSwapy1, layoutSwapy2, gridMode, showCharts]);

  {/* Toogle drop area display */}
  const toggleDropGrid = () => {
    setGridMode(!gridMode); 
  };

  {/* Definning editor's area */}
  const EditorArea = () => {
    return (
      <div
        className="dropArea border-2 p-4 z-10 mt-10 position-absolute h-auto bg-[#000000bd] rounded-sm transition-all duration-1000 items-center align-middle flex"
        style={{ width: '98.5%', minHeight: '100%'}}
      >
        {/* Close editor icon X */}
        <div className="closeEditor absolute top-0 right-0 m-4 z-10">
            <Cross className="m-1 h-6 w-6 fill-[white] hover:fill-[#e2e8f0] rotate-45" onClick={toggleDropGrid}>
            </Cross>
        </div>

        {/* Editor container */}
        <div id="editorContainer" className="">       
          <div className="editor-container px-15 items-center">
            <CardHeader className="items-center pb-2">
                <CardTitle>Edit your file here!</CardTitle>
                <CardDescription></CardDescription>
            </CardHeader>
          </div>  
          <MyEditor insertedImage={insertedImage}/>
        </div>
      </div>
    );
  };

  useEffect(() => {
    /* if (!orgId) return; */

    const fetchData = async () => {
      setLoading(true);

      try {
        const data = await apiFetch("/api/dashboard-default");
        if (!data) return;
        const devicesNames = data?.devicesNames ?? [];
        setDevices(devicesNames);
        setDevicesAvailable(true);
setProduct(data?.product?.product ?? "");

        setRole(data?.role || "member");
        /* console.log("[DEBUG] Role set to:", data?.role || "member"); */

      } catch (error) {
        console.error("Error fetching devices:", error);
        toastError(error);
      } finally {
        setLoading(false);
        setDevicesLoading(false);
      }
    };

    fetchData();
  }, [orgId]);
  
  const getSwapyGridLayout = (gridId) => {
    const container = document.getElementById(gridId);
    const layout = [];

    if (!container) return layout;

    const items = container.querySelectorAll("[data-swapy-slot]");

    items.forEach((item) => {
      const slot = item.getAttribute("data-swapy-slot");
      const itemChild = item.querySelector("[data-swapy-item]");
      const itemAttr = itemChild?.getAttribute("data-swapy-item");
      const componentId = itemChild?.querySelector("div[id]")?.id;

      if (slot && itemAttr && componentId) {
        layout.push({
          slot,
          item: slot,
          componentId
        });
      }
    });

    return layout;
  };

  const fetchSavedLayout = async () => {
    try {
        const data = await apiFetch("/api/retrieve-layouts");
        if (!data) return;
        const dashboardAudio = data?.layoutData?.[0]?.dashboardAudio;
        if (dashboardAudio) {
          const restoredLayout1 = {};
          (dashboardAudio?.swapyGrid1 ?? []).forEach(({ slot, componentId }) => {
            restoredLayout1[slot] = componentId;
          });

          const restoredLayout2 = {};
          (dashboardAudio?.swapyGrid2 ?? []).forEach(({ slot, componentId }) => {
            restoredLayout2[slot] = componentId;
          });

          setLayout1(restoredLayout1);

          setLayout2(restoredLayout2);
        }
      } catch (error) {
        console.error("[WARN] Error retrieving layouts:", error);
        toastError(error);
      }
  };

  useEffect(() => {
    /* if (!orgId) return; */
    fetchSavedLayout();
  }, [orgId]);

  const saveSwapyLayouts = async () => {
    setLoading(true);
    const layoutData = {
      swapyGrid2: getSwapyGridLayout("swapyGrid2"),
      swapyGrid1: getSwapyGridLayout("swapyGrid1"),
    };

    try {
      const data = await apiFetch("/api/save-layouts-audio", {
        method: "POST",
        body: {
          layout: layoutData
        }
      });
      if (!data) return;
      /* fetchSavedLayout() */

      toast.success("Layout saved successfully!", {
          className: "mt-[50px]",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

    } catch (error) {
      console.error("[WARN] Error saving layout:", error);
      toastError(error, "Error saving layout");
    } finally {
      setLoading(false);
    }
  };

  const fetchData = useCallback(async () => {
    try {
      const response = await fetch("http://etl-dev.metrics.nc:6789", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          index: "dynagrid-http-bird-*",
          body: {
            query: {
              bool: {
                must: [
                  { match: { device: device } },
                  { range: { timestamp: { gte: startDate, lte: endDate } } },
                ],
              },
            },
          },
        }),
      });
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      const result = await response.json();
      setData(result?.hits?.hits ?? []);
    } catch (error) {
      console.error("Error fetching data", error);
      toastError(error);
    }
  }, [device, startDate, endDate]);

  useEffect(() => {
    if (device) {
      fetchData();
    }
  }, [device, startDate, endDate, fetchData]);

  const renderDynamicLayout1 = () => {
    if (!layoutSwapy1) return null;
  
    return Object.entries(layoutSwapy1).map(([slot, componentId]) => {
      const Component = COMPONENTS_MAP_GRID1[componentId];
      if (!Component) return null;

      return (
        <div key={slot} data-swapy-slot={slot}>
          <div data-swapy-item={slot}>
            <div id={componentId} className="m-2">
              {statsLoading || !appliedRange ? (
                <WidgetSkeleton variant="chart" />
              ) : (
              <Component
                detections={detections}
                frameDetections={frameDetections}
                startDate={appliedRange.start}
                endDate={appliedRange.end}
              />
              )}
              {/* <Button
                variant="outline"
                size="icon"
                className="w-[40px] m-2"
                onClick={() => handleAddIMG(componentId)}
              >
                <Cross className="m-1 h-4 w-4" />
              </Button> */}
            </div>
          </div>
        </div>
      );
    });
  };

  const renderDynamicLayout2 = () => {
    if (!layoutSwapy2) return null;
  
    return Object.entries(layoutSwapy2).map(([slot, componentId]) => {
      const Component = COMPONENTS_MAP_GRID2[componentId];
      if (!Component) return null;

      return (
        <div key={slot} data-swapy-slot={slot}>
          <div data-swapy-item={slot}>
            <div id={componentId} className="m-2">
              {statsLoading || !appliedRange ? (
                <WidgetSkeleton variant="stat" />
              ) : (
              <Component
                temperature={temperature}
                tempTrend={tempTrend}
                startDate={appliedRange.start}
                endDate={appliedRange.end}
                device={displayedDevice}
                melody={melody}
                volume={volume}
                volumeTrend={volumeTrend}
              />
              )}
              {/* <Button
                variant="outline"
                size="icon"
                className="w-[40px] m-2"
                onClick={() => handleAddIMG(componentId)}
              >
                <Cross className="m-1 h-4 w-4" />
              </Button> */}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div>
      <div className="dashboard-container dashboard-page">
        {/* Report feature only available for admins */}
          {/* {role === "org:admin" && (
            <div>
              <Button variant="outline" size="icon" className="w-[180px] " onClick={toggleDropGrid} id="report">
                <p className="mt-3 ">Create a report</p>
                <ChevronRight className="m-1 h-6 w-6" />
              </Button>

              {gridMode && (
                <EditorArea/>
              )}
            </div>
          )} */}

        <DashboardFilterBar
          devices={(Array.isArray(devices) ? devices : []).map((name) => ({ key: name, label: name }))}
          selected={value}
          onSelect={setValue}
          devicesLoading={devicesLoading}
          startDate={startDate}
          endDate={endDate}
          onStartDateChange={setStartDate}
          onEndDateChange={setEndDate}
          onSearch={handleFilterClick}
          searching={searching}
          pending={pendingSearch}
          hasResults={showCharts}
        />

        {showCharts ? (
          <div
            className={`swapy-grids grid 
            gap-4 `}
            style={{ paddingTop: "2rem" }}
          >  
              <div id={`${!gridMode ? "swapyGrid2" : undefined}`} className={`swapy-grid-1 swapy-stat-grid grid gap-4`}>
                { layoutSwapy2 && (
                    renderDynamicLayout2()
                )}
              </div>

              <div id={`${!gridMode ? "swapyGrid1" : undefined}`} className={`swapy-grid-1 `}>
                { layoutSwapy1 && (
                    renderDynamicLayout1()
                )}
              </div>
          </div>
        ) : (
          <div className="dashboard-empty-state" role="status">
            {loading ? (
              <h3>Loading…</h3>
            ) : devicesAvailable && devices.length === 0 ? (
              <>
                <h3>No devices available</h3>
                <p>There are no devices linked to this organization yet.</p>
              </>
            ) : (
              <>
                <h3>Select a device to get started</h3>
                <p>Choose a device and a date range, then click the search button to load its data.</p>
              </>
            )}
          </div>
        )}

        {/* Save changes*/}
        <Button
          variant=""
          size="icon"
          className="w-[150px] m-2 fixed bottom-4 right-4 p-3"
          onClick={saveSwapyLayouts}
          disabled={!showCharts || loading || searching}
          id="save-button"
        >
          Save changes
        </Button>
      </div>
        <ToastContainer/>
    </div>
  );
};

export default Dashboard;